import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import { analyzeOnboarding } from '../../lib/ai'
import './Onboarding.css'

const QUESTIONS = [
  // BLOC 1 - Situatie financiara
  {
    id: 'venit_lunar',
    bloc: 'Situatia ta financiara',
    intrebare: 'Care este venitul tau lunar net aproximativ?',
    tip: 'select',
    optiuni: [
      { label: 'Sub 2.000 lei', value: 1500 },
      { label: '2.000 – 3.500 lei', value: 2750 },
      { label: '3.500 – 5.000 lei', value: 4250 },
      { label: '5.000 – 8.000 lei', value: 6500 },
      { label: 'Peste 8.000 lei', value: 9000 },
    ],
  },
  {
    id: 'are_rata',
    bloc: 'Situatia ta financiara',
    intrebare: 'Platesti chirie sau rata la banca?',
    tip: 'select',
    optiuni: [
      { label: 'Nu platesc', value: 'nu' },
      { label: 'Platesc chirie', value: 'chirie' },
      { label: 'Am rata la banca', value: 'rata' },
    ],
  },
  {
    id: 'suma_rata',
    bloc: 'Situatia ta financiara',
    intrebare: 'Cat platesti lunar pentru chirie / rata?',
    tip: 'select',
    conditie: (r) => r.are_rata !== 'nu',
    optiuni: [
      { label: 'Sub 500 lei', value: 400 },
      { label: '500 – 1.000 lei', value: 750 },
      { label: '1.000 – 2.000 lei', value: 1500 },
      { label: 'Peste 2.000 lei', value: 2500 },
    ],
  },
  {
    id: 'are_copii',
    bloc: 'Situatia ta financiara',
    intrebare: 'Ai copii in intretinere?',
    tip: 'select',
    optiuni: [
      { label: 'Nu am copii', value: 0 },
      { label: 'Un copil', value: 1 },
      { label: 'Doi copii', value: 2 },
      { label: 'Trei sau mai multi', value: 3 },
    ],
  },
  // BLOC 2 - Comportament de joc
  {
    id: 'ani_de_joc',
    bloc: 'Obiceiurile tale de joc',
    intrebare: 'De cat timp joci la pacănele?',
    tip: 'select',
    optiuni: [
      { label: 'Mai putin de un an', value: 0.5 },
      { label: '1 – 2 ani', value: 1.5 },
      { label: '2 – 5 ani', value: 3.5 },
      { label: '5 – 10 ani', value: 7 },
      { label: 'Peste 10 ani', value: 12 },
    ],
  },
  {
    id: 'frecventa',
    bloc: 'Obiceiurile tale de joc',
    intrebare: 'Cat de des joci pe saptamana?',
    tip: 'select',
    optiuni: [
      { label: 'O data sau mai rar', value: 1 },
      { label: 'De 2-3 ori', value: 2.5 },
      { label: 'De 4-5 ori', value: 4.5 },
      { label: 'Aproape zilnic', value: 6 },
      { label: 'In fiecare zi', value: 7 },
    ],
  },
  {
    id: 'suma_per_sesiune',
    bloc: 'Obiceiurile tale de joc',
    intrebare: 'Cat cheltuiesti in medie per sesiune de joc?',
    tip: 'select',
    optiuni: [
      { label: 'Sub 50 lei', value: 35 },
      { label: '50 – 150 lei', value: 100 },
      { label: '150 – 300 lei', value: 225 },
      { label: '300 – 500 lei', value: 400 },
      { label: 'Peste 500 lei', value: 700 },
    ],
  },
  {
    id: 'a_jucat_cu_bani_facturi',
    bloc: 'Obiceiurile tale de joc',
    intrebare: 'Ai jucat vreodata cu bani destinati facturilor sau mancarii?',
    tip: 'select',
    optiuni: [
      { label: 'Niciodata', value: false },
      { label: 'O data sau de doua ori', value: 'rar' },
      { label: 'De mai multe ori', value: 'des' },
      { label: 'Se intampla frecvent', value: 'frecvent' },
    ],
  },
  {
    id: 'a_imprumutat',
    bloc: 'Obiceiurile tale de joc',
    intrebare: 'Ai imprumutat bani de la cineva ca sa joci?',
    tip: 'select',
    optiuni: [
      { label: 'Nu, niciodata', value: false },
      { label: 'O data', value: 'o_data' },
      { label: 'De cateva ori', value: 'cateva' },
      { label: 'Da, de mai multe ori', value: 'des' },
    ],
  },
  // BLOC 3 - Context personal
  {
    id: 'are_partener',
    bloc: 'Contextul tau personal',
    intrebare: 'Ai un partener / parteneră sau familie care stie ca joci?',
    tip: 'select',
    optiuni: [
      { label: 'Nu am partener', value: 'singur' },
      { label: 'Da, stie', value: 'stie' },
      { label: 'Nu stie', value: 'nu_stie' },
      { label: 'Stie partial', value: 'partial' },
    ],
  },
  {
    id: 'a_incercat_sa_se_opreasca',
    bloc: 'Contextul tau personal',
    intrebare: 'Ai incercat sa te opresti din joc inainte?',
    tip: 'select',
    optiuni: [
      { label: 'Nu, e prima oara', value: false },
      { label: 'Am incercat o data', value: 'o_data' },
      { label: 'Am incercat de mai multe ori', value: 'des' },
      { label: 'Mereu esueaza', value: 'mereu' },
    ],
  },
  {
    id: 'motivatie',
    bloc: 'Contextul tau personal',
    intrebare: 'Ce te-a adus aici azi?',
    tip: 'select',
    optiuni: [
      { label: 'Am pierdut prea mult recent', value: 'pierderi' },
      { label: 'Familia m-a rugat', value: 'familie' },
      { label: 'Vreau sa economisesc', value: 'economii' },
      { label: 'Ma simt dependent', value: 'dependent' },
      { label: 'Altceva', value: 'altceva' },
    ],
  },
]

export default function Onboarding() {
  const { user, saveUserProfile } = useApp()
  const navigate = useNavigate()
  const [step, setStep] = useState(0) // -1 = intro
  const [raspunsuri, setRaspunsuri] = useState({})
  const [loading, setLoading] = useState(false)
  const [showIntro, setShowIntro] = useState(true)

  // Filtreaza intrebarile in functie de conditii
  const intrebariActive = QUESTIONS.filter(q => !q.conditie || q.conditie(raspunsuri))
  const intrebare = intrebariActive[step]
  const progres = Math.round(((step) / intrebariActive.length) * 100)

  function selecteazaRaspuns(value) {
    const nouRaspunsuri = { ...raspunsuri, [intrebare.id]: value }
    setRaspunsuri(nouRaspunsuri)

    setTimeout(() => {
      if (step < intrebariActive.length - 1) {
        setStep(step + 1)
      } else {
        finalizeaza(nouRaspunsuri)
      }
    }, 300)
  }

  async function finalizeaza(r) {
    setLoading(true)
    try {
      const aiProfil = await analyzeOnboarding({ ...r, userId: user?.id })
      await saveUserProfile(aiProfil)
      navigate('/rezultate')
    } catch (e) {
      console.error('Onboarding error:', e)
      // Fallback: use default profile
      try {
        const { getDefaultProfile } = await import('../../lib/ai')
        await saveUserProfile(getDefaultProfile())
        navigate('/rezultate')
      } catch (e2) {
        console.error('Fallback error:', e2)
      }
      setLoading(false)
    }
  }

  if (showIntro) {
    return (
      <div className="onboarding-page">
        <div className="onboarding-intro">
          <div className="ob-logo">STOP <span>PACANELE</span></div>
          <div className="ob-intro-icon">👋</div>
          <h1>Hai sa te cunoastem putin.</h1>
          <p>
            Urmatoarele 12 intrebari ne ajuta sa iti cream un program complet personalizat —
            bugetul tau real, mesajele potrivite pentru tine, si nivelul de suport de care ai nevoie.
          </p>
          <p className="ob-intro-note">
            Raspunsurile sunt anonime si raman doar la tine. Dureaza aproximativ 2 minute.
          </p>
          <button className="btn-primary btn-lg" onClick={() => setShowIntro(false)}>
            Incepe
          </button>
          <button className="ob-skip-btn" onClick={() => navigate('/')}>
            Nu sunt pregatit acum
          </button>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="onboarding-page">
        <div className="onboarding-loading">
          <div className="ob-logo">STOP <span>PACANELE</span></div>
          <div className="ob-spinner" />
          <h2>Se analizeaza profilul tau...</h2>
          <p>AI-ul calculeaza bugetul personalizat si nivelul de suport de care ai nevoie.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-card">
        <div className="ob-header">
          <div className="ob-logo">STOP <span>PACANELE</span></div>
          <div className="ob-progress-wrap">
            <div className="ob-progress-bar">
              <div className="ob-progress-fill" style={{ width: `${progres}%` }} />
            </div>
            <span className="ob-progress-label">{step + 1} / {intrebariActive.length}</span>
          </div>
        </div>

        <div className="ob-bloc">{intrebare?.bloc}</div>
        <h2 className="ob-intrebare">{intrebare?.intrebare}</h2>

        <div className="ob-optiuni">
          {intrebare?.optiuni.map(opt => (
            <button
              key={opt.label}
              className={`ob-opt ${raspunsuri[intrebare.id] === opt.value ? 'selected' : ''}`}
              onClick={() => selecteazaRaspuns(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>

        {step > 0 && (
          <button className="ob-back" onClick={() => setStep(step - 1)}>
            ← Inapoi
          </button>
        )}
      </div>
    </div>
  )
}
